import React, { FC } from 'react';
// import { useTranslation } from 'react-i18next';
// import MisValesAhorroService from '../../services/MisValesAhorroService';
// import useAPIError from '../../hooks/useAPIError';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/AppContext';
import tarjetasCaprabo from '../../assets/images/tarjetas-caprabo.png';
import ValeComponentActivableCanjeable from './ValeComponentActivableCanjeable';
import IconX from '../../Icons/IconX';
import { HostProvider } from '../../utils/HostProvider';

type Props = {
  vale: {
    tipoLista: number;
    numOferta: string;
    fechaIniVigencia: any;
    fechaFinVigencia: string;
    fechaFinCanjeoDTO: string;
    fechaFinActivacion: string;
    fechaFinCanjeoPromo: string;
    visualizar: boolean;
    activable: boolean;
    gupoInternoVisualizar: string;
    grupoInternoActivacion: string;
    valeEAN: string;
    exclusividad: boolean;
    entregada: boolean;
    canjeada: boolean;
    activada: boolean;
    idioma: string;
    textoReclamo: string;
    textoTitulo: string;
    textoDescripcion1: string;
    textoDescripcion2: string;
    canalActivacion: string;
    canales: object;
    fechaActivacion: string;
    tipoVale: string;
    scoring: number;
    codImpacto: number;
    planAdhesion: number;
    denominacionPlanAdhesion: string;
    soportePostal: number;
    denominacionSoportePostal: string;
    valeDestacado: string;
    estructurasComerciales: object;
    tienda: string;
    fechaCanjeo: any;
    horaCanjeo: any;
    locale: string;
    preferencia: string;
    fechaInicioCanjeo: string;
    showValeEntrega: boolean;
    tipoReclamo: string;
    canalesVisualizacion: object;
    showPopup: boolean;
  };
  // index: number;
  // tipo: string;
  // fila: number;
  // cagarVales: () => void;
};
const ValeInfo: FC<Props> = ({ vale }) => {
  const isEroski = HostProvider.isEroski();
  const oferta = vale.textoReclamo;
  const unidad = vale.tipoReclamo;
  const dataApp = useAppStore();
  const { t } = useTranslation();
  const CUPON_CANJEADO = 3;
  const CUPON_ACTIVADO = 2;
  const CUPON_NO_ACTIVADO = 1;
  const isDestacado = (vale.valeDestacado &&
    vale.valeDestacado === '1') as boolean;
  const isPromocion = vale.tipoLista === 4 && !vale.exclusividad;
  const isCanjeado = (vale.tipoLista === CUPON_CANJEADO) as boolean;
  const isActivado = (vale.tipoLista === CUPON_ACTIVADO) as boolean;
  const isNoActivado = (vale.tipoLista === CUPON_NO_ACTIVADO) as boolean;
  let clasesBloqueValeValor = 'bloque-vale__valor';
  if (!isEroski && isDestacado) {
    if (isCanjeado) {
      clasesBloqueValeValor = 'bloque-vale__valor_destacado_canjeado';
    } else {
      clasesBloqueValeValor = 'bloque-vale__valor_destacado';
    }
  }
  let clasesBloqueValeBasico = '';
  if (!isDestacado && (isActivado || (isEroski && isNoActivado))) {
    clasesBloqueValeBasico = ' bloque-vale__basico';
  } else if (!isDestacado && isCanjeado) {
    clasesBloqueValeBasico =
      ' bloque-vale__basico bloque-vale bloque-vale-container__canjeado';
  } else if (isCanjeado) {
    clasesBloqueValeBasico = ' bloque-vale bloque-vale-container__canjeado';
  }
  const claseContainerVale =
    (isDestacado || isPromocion) && !isEroski
      ? 'bloque-vale-container_destacado u-margin-bottom'
      : 'bloque-vale-container u-margin-bottom';

  return (
    <div
      id={`valeinfo-${vale.valeEAN}-${vale.tipoLista}`}
      className="detalle-container u-margin-bottom no-active"
    >
      <div className={`bloque-vale__detalle-visible ${clasesBloqueValeBasico}`}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <span
          className="icon icon-medium bloque-vale__close"
          // onMouseDown={() => {
          //   Hide();
          // }}
        >
          <IconX classCss="" />
        </span>

        <div className={claseContainerVale}>
          {vale.valeDestacado && vale.valeDestacado === '1' ? (
            <div
              className={`etiqueta__destacado${
                // eslint-disable-next-line no-nested-ternary
                HostProvider.isCaprabo()
                  ? vale.canjeada
                    ? '_caprabo-canjeado'
                    : '_caprabo'
                  : vale.canjeada
                  ? '-canjeado'
                  : ''
              }
                    }`}
            >
              {t('vales.destacado').toUpperCase()}
            </div>
          ) : (
            ''
          )}
          <div
            className={`divider divider__img--v ${
              isDestacado && isEroski ? '' : ' display-none'
            }`}
          />
          <div className="bloque-vale-content">
            <div
              className={`${clasesBloqueValeValor}
                     ${oferta.length > 2 ? ' bloque-vale__num-redu' : ''}`}
            >
              {' '}
              {(() => {
                if (
                  vale.textoReclamo &&
                  vale.textoReclamo.toUpperCase() === 'GRATIS'
                ) {
                  return (
                    <>
                      <span className="bloque-vale__gratis">
                        {t('vales.gratis').toUpperCase()}
                      </span>
                    </>
                  );
                }
                if (dataApp.lang === 'eu' && unidad === '%') {
                  return (
                    <>
                      <span className="bloque-vale__num ">
                        <sup>{unidad}</sup>
                        {oferta}
                      </span>
                    </>
                  );
                }
                return (
                  <>
                    <span className="bloque-vale__num ">
                      {oferta}
                      <sup>{unidad}</sup>
                    </span>
                  </>
                );
              })()}
              <ValeComponentActivableCanjeable vale={vale} />
            </div>
            <div
              className={`${
                !isEroski && (isDestacado || isPromocion)
                  ? 'bloque-vale__texto_destacado'
                  : 'bloque-vale__texto'
              }`}
            >
              <p className="bloque-vale__titulo">{vale.textoTitulo}</p>
              <p>
                {vale.textoDescripcion1}
                {vale.textoDescripcion2}
              </p>
              <div className="bloque-vale__img">
                <div
                  className={`img ${
                    vale.tipoVale === 'ValeMonedero' ? '' : ' display-none'
                  }`}
                >
                  {isEroski ? (
                    <img
                      src="../../assets/images/tarjetas.png"
                      alt="imagen de las tarjetas Eroski"
                    />
                  ) : (
                    <img
                      src={tarjetasCaprabo}
                      alt="imagen de las tarjetas Caprabo"
                    />
                  )}
                </div>
              </div>
              <div className="icon-link-block u-margin-bottom-small u-display-none-only-mobile-tablet">
                <a
                  href="#legal-conditions"
                  className="legal-conditions icon-link u-align-items-baseline"
                  rel="noopener noreferrer"
                >
                  <span className="u-font-medium">
                    {isEroski
                      ? t('vales.condiciones-legales-titulo')
                      : t('caprabo.cupones.condiciones-legales-titulo')}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="bloque-vale__info">
          {(() => {
            if (vale.tipoVale === 'ValeMonedero') {
              return (
                <>
                  <p className="u-font-normal display-none">
                    Información nutricional
                  </p>
                  <div className="img u-margin-bottom-small display-none">
                    <img
                      src="../../assets/images/calidad.png"
                      alt="imagen de tipo de calidad"
                    />
                  </div>
                </>
              );
            }
            return false;
          })()}

          <div className="botonera botonera__inline">
            {vale.tipoLista === 1 && (
              <>
                <button
                  type="button"
                  className="btn btn-secundary u-margin-right display-none"
                  // onClick={() => {
                  //   Hide();
                  // }}
                >
                  No lo quiero
                </button>
                <button
                  type="button"
                  className="btn btn-default activate-button"
                  // onClick={() => activarVale(vale)}
                >
                  {t('vales.activarVale')}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValeInfo;
